export const Environment = {
  discovery: 'https://androme-lab.melitacable.com/api/v1/bootstrap/discover',
  system: 'SMARTTV_TIZEN',
  Oauth: {
    clientId: 'androme.tv-smarttv-tizen-1',
    redirectUri: 'https://tv-lab.melitacable.com',
    uri: 'https://androme-lab.melitacable.com/api/oauth/v1/auth/authorize',
    secret: 'DbM6HeMfmYpFA3Bwyofm',
  },
  Castlabs: {
    // use web license key so we can watch video on dev websites
    licenseKey:
      'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpbHYiOmZhbHNlLCJ0eXBlIjoiV2ViIiwidXJscyI6WyJodHRwczovL3R2LWxhYi5tZWxpdGFjYWJsZS5jb20iXSwia2lkIjoxNDQ2fQ.fyqCk-mJWzthMzW-Y32l3EPXmlUmq_CZY6OaNmhyBqYzD_xpcUXqpS2DFY5rNYJo4iDNksTKf-fYHfWNbS0THaxlES7fHrPgnlDfxJ3aWkzlwggGwAHieJ62itQZZmFIJhw51EI8FXXx-3YlnY9sip0DDx3YoHUCvsHJCH8Oiw3__OTX0upQmIMF43idi3ZydayLWTpMP4HwTRVgjMHiRROMoR1W8d1dXHKBwCjYoMAlu8i41L8iVgohJdABYiIMsd2Kzoi8mUT0yIUCL5rztZpXmlA_XWaCW_FTLfWCYwM91tXi79OHtljr01R6NQhpPpCWr1Z2WS_WnXTOd1x2Mg',
    drmMerchant: 'melita',
    drmEnvironment: 'DRMtoday_STAGING',
    drmStaging: true,
    defaultDrmProvider: 'PLAYREADY',
  },
  atv_ott_rights: ['LINEAR', 'NPVR'],
  atv_replay_ott_rights: ['REPLAY'],
};
